import { Component, Input, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  AddressDto,
  ThirdPartyLookupDto,
  WorkingSiteService,
} from '@digiwall/goliath-contacts/proxy';
import { CountryStore } from '@digiwall/goliath-core';
import { DocRole } from '@digiwall/goliath-core/proxy';

import { map, Observable } from 'rxjs';
import { DocSupplierDeliveryAddressComponent } from './doc-supplier-delivery-address.component';

@Component({
  selector: 'document-doc-supplier-addresses',
  templateUrl: './doc-supplier-addresses.component.html',
  imports: [DocSupplierDeliveryAddressComponent],
})
export class DocSupplierAddressesComponent {
  @Input() docForm: FormGroup;
  @Input() deliveryAddresses$: Observable<AddressDto[]>;
  @Input() invoicingAddresses$?: Observable<AddressDto[]>;
  @Input() docRoleInput: DocRole;
  @Input() showSearch: boolean = true;

  docRole = DocRole;

  workingSites$: Observable<ThirdPartyLookupDto[]>;

  countryStore = inject(CountryStore);

  constructor(protected workingSiteService: WorkingSiteService) {
    this.workingSites$ = this.workingSiteService
      .getLookupList({ onlyActive: true, ids: [], queryProperties: [], sorting: [] })
      .pipe(map(x => x.items));
  }
}
